import React, { FC, PropsWithChildren } from 'react';

import './DashboardChartWrapper.scss';

export const DashboardChartWrapper: FC<PropsWithChildren> = (props) => {
	return <div {...props} className="dashboard-chart-wrapper" />;
};
